import React, { useCallback, useState } from 'react';
import { BugsnagService } from '../../../services/Bugsnag.service';
import { applicantService } from '../../../apiServices/applicant.service';
export var BugsnagErrorsTestPage = function () {
    var blockStyle = { paddingBottom: '30px' };
    var _a = useState(''), errorMsg = _a[0], setErrorMsg = _a[1];
    var handleInputChange = useCallback(function (e) { return setErrorMsg(e.target.value); }, []);
    var handleIssuerClick = useCallback(function () {
        BugsnagService.emitHandledError(errorMsg);
    }, [errorMsg]);
    var _b = useState(false), shouldRenderErrorBound = _b[0], setShouldRenderErrorBound = _b[1];
    var handleEBRClick = useCallback(function () {
        setShouldRenderErrorBound(true);
    }, []);
    var handleAPIErrorClick = useCallback(function () {
        applicantService.saveApplicants({}, {});
    }, []);
    return (React.createElement("div", { style: { padding: '40px' } },
        React.createElement("div", { style: blockStyle },
            React.createElement("input", { type: "text", value: errorMsg, onChange: handleInputChange }),
            React.createElement("button", { onClick: handleIssuerClick }, "Issue handled error"),
            React.createElement("pre", null, "Should emit handled error with specific text")),
        React.createElement("div", { style: blockStyle },
            shouldRenderErrorBound && (React.createElement("input", { type: "text" }, "Obvious error is here")),
            React.createElement("button", { onClick: handleEBRClick }, "Issue EBR"),
            React.createElement("pre", null, "Should emit ErrorBoundary React case")),
        React.createElement("div", { style: blockStyle },
            React.createElement("button", { onClick: handleAPIErrorClick }, "Issue API Error"),
            React.createElement("pre", null, "Should emit API communication error"))));
};
